<template>
  <a-modal
      :visible="visible"
      title="查看菜单"
      :footer="null"
      @cancel="handleCancel"
      width="800px"
  >
    <a-table
        bordered
        :dataSource="menuList"
        :loading="loading"
        :pagination="false"
        rowKey="id"
    >
      <a-table-column key="name" title="菜单名称" data-index="name"/>
      <a-table-column key="type" title="菜单类型" data-index="type"/>
      <a-table-column key="permission" title="权限code" data-index="permission"/>
    </a-table>
  </a-modal>
</template>

<script>
import {getMenusByRoleUuid} from "@/api/setting/role";

export default {
  name: "MenuModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    role: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      menuList: [],
    };
  },
  watch: {
    visible(val) {
      if (val && this.role.uuid) {
        this.getMenuList();
      }
    },
  },
  methods: {
    getMenuList() {
      this.loading = true;
      getMenusByRoleUuid(this.role.uuid)
          .then((res) => {
            this.loading = false;
            if (Array.isArray(res)) {
              this.menuList = res;
            }
          })
          .catch(() => {
            this.loading = false;
          });
    },
    handleCancel() {
      this.$emit("update:visible", false);
      this.menuList = [];
    },
  },
};
</script>